import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from './useAuth';
import { LoadingScreen } from '@/components/ui/LoadingScreen';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading, isAllowedUser } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingScreen />;
  }
  if (!user) {
    return <Navigate to="/sign-in" replace state={{ from: location }} />;
  }
  if (!isAllowedUser) {
    return <Navigate to="/courses" replace />;
  }
  return <>{children}</>;
}
